import CV from "../../assets/Koshikawa_CV.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} className="btn" download="Koshikawa_CV.pdf">
        Download Resume
      </a>
      <a href="#contact" className="btn btn-primary ">
        Start a conversation
      </a>
    </div>
  );
};

export default CTA;
